import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { API_URL, authHeaders, toNum } from './utils';
import FilterBar from './FilterBar';
import '../../components/componenetStyle/ListaUrzadzen.css';
import { useAuth } from '../../auth/AuthContext';

const ListaStawekVat = () => {
  const { hasPermission } = useAuth();
  const canManageWarehouse = hasPermission('warehouse_manage');
  const [rows, setRows] = useState([]);
  const [filter, setFilter] = useState('active');
  const [search, setSearch] = useState('');
  const [isAdding, setIsAdding] = useState(false);
  const [newRow, setNewRow] = useState({ nazwa: '', proc: '' });
  const [editingId, setEditingId] = useState(null);
  const [edit, setEdit] = useState({ nazwa: '', proc: '' });

  const query = useMemo(() => {
    const q = new URLSearchParams();
    if (filter !== 'all') q.set('active', filter === 'active' ? 'true' : 'false');
    if (search.trim()) q.set('search', search.trim());
    q.set('limit', '500'); q.set('sort', 'proc');
    return q.toString();
  }, [filter, search]);

  const fetchRows = async () => {
    const { data } = await axios.get(`${API_URL}/slowniki/stawki-vat?${query}`, { headers: authHeaders() });
    setRows(data || []);
  };

  useEffect(() => { fetchRows(); /* eslint-disable-next-line */ }, [query]);

  const saveAdd = async () => {
    if (!canManageWarehouse) return;
    const payload = { nazwa: newRow.nazwa?.trim(), proc: toNum(newRow.proc, 2), active: true };
    if (!payload.nazwa || payload.proc === null) return alert('Podaj nazwę i procent.');
    await axios.post(`${API_URL}/slowniki/stawki-vat`, payload, { headers: authHeaders() });
    setIsAdding(false);
    setNewRow({ nazwa: '', proc: '' });
    fetchRows();
  };

  const beginEdit = (r) => { setEditingId(r.id); setEdit({ nazwa: r.nazwa, proc: r.proc }); };
  const cancelEdit = () => { setEditingId(null); setEdit({ nazwa: '', proc: '' }); };
  const saveEdit = async (id) => {
    if (!canManageWarehouse) return;
    await axios.put(`${API_URL}/slowniki/stawki-vat/${id}`, {
      nazwa: edit.nazwa?.trim(),
      proc: toNum(edit.proc, 2)
    }, { headers: authHeaders() });
    cancelEdit();
    fetchRows();
  };

  const archive = async (id) => {
    if (!canManageWarehouse) return;
    if (!window.confirm('Zarchiwizować tę stawkę VAT?')) return;
    await axios.delete(`${API_URL}/slowniki/stawki-vat/${id}`, { headers: authHeaders() });
    fetchRows();
  };
  const restore = async (id) => {
    if (!canManageWarehouse) return;
    await axios.patch(`${API_URL}/slowniki/stawki-vat/${id}/restore`, {}, { headers: authHeaders() });
    fetchRows();
  };

  return (
    <div className="lista-urzadzen-container">
      <div className="header">
        <h2>Stawki VAT</h2>
        {canManageWarehouse ? <button className="add-button" onClick={() => setIsAdding(true)}>Dodaj nowe</button> : null}
      </div>
      <FilterBar filter={filter} setFilter={setFilter} search={search} setSearch={setSearch} />
      <table className="lista-urzadzen-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Nazwa</th>
            <th>Procent</th>
            <th>Akcje</th>
          </tr>
        </thead>
        <tbody>
          {isAdding && (
            <tr>
              <td>Nowa</td>
              <td><input value={newRow.nazwa} onChange={(e) => setNewRow((p) => ({ ...p, nazwa: e.target.value }))} placeholder="np. VAT 23%" /></td>
              <td><input type="number" step="0.01" value={newRow.proc} onChange={(e) => setNewRow((p) => ({ ...p, proc: e.target.value }))} placeholder="23" /></td>
              <td />
            </tr>
          )}
          {rows.length === 0 ? (
            <tr><td colSpan="4">Brak danych</td></tr>
          ) : rows.map((r) => (
            <tr key={r.id}>
              <td>{r.id}</td>
              {editingId === r.id ? (
                <>
                  <td><input value={edit.nazwa} onChange={(e) => setEdit((p) => ({ ...p, nazwa: e.target.value }))} /></td>
                  <td><input type="number" step="0.01" value={edit.proc} onChange={(e) => setEdit((p) => ({ ...p, proc: e.target.value }))} /></td>
                  <td>
                    {canManageWarehouse ? <button onClick={() => saveEdit(r.id)}>Zapisz</button> : null}
                    {canManageWarehouse ? <button onClick={cancelEdit}>Anuluj</button> : null}
                  </td>
                </>
              ) : (
                <>
                  <td>{r.nazwa}</td>
                  <td>{Number(r.proc).toFixed(2)}</td>
                  <td>
                    {r.active ? (
                      <>
                        {canManageWarehouse ? <button onClick={() => beginEdit(r)}>Edytuj</button> : null}
                        {canManageWarehouse ? <button onClick={() => archive(r.id)}>Archiwizuj</button> : null}
                      </>
                    ) : (
                      canManageWarehouse ? <button onClick={() => restore(r.id)}>Przywróć</button> : null
                    )}
                  </td>
                </>
              )}
            </tr>
          ))}
        </tbody>
      </table>
      {isAdding && canManageWarehouse && (
        <div className="new-device-actions">
          <button onClick={saveAdd}>Zapisz</button>
          <button onClick={() => { setIsAdding(false); setNewRow({ nazwa: '', proc: '' }); }}>Anuluj</button>
        </div>
      )}
    </div>
  );
};

export default ListaStawekVat;
